<app-org-questions-form
    [questions]="questions"
    [answersFormGroup]="answersFormGroup"
    [commentsFormGroup]="commentsFormGroup"
    [additionalNotesFormGroup]="additionalNotesFormGroup"
    [disabled]="disabled"
    [submitted]="submitted"
></app-org-questions-form>